var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tapes-tabs" }, [
    _vm.isTabsInitialized
      ? _c(
          "div",
          [
            _c(
              "v-tabs",
              {
                attrs: {
                  "next-icon": "mdi-arrow-right-bold-box-outline",
                  "prev-icon": "mdi-arrow-left-bold-box-outline",
                  "show-arrows": "",
                },
                model: {
                  value: _vm.tab,
                  callback: function ($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab",
                },
              },
              [
                _c("v-tabs-slider"),
                _vm._v(" "),
                _vm._l(_vm.items, function (item, index) {
                  return _c("v-tab", { key: index }, [
                    _c("span", [
                      _vm._v(
                        "\n                       " +
                          _vm._s(item.label) +
                          "\n                "
                      ),
                    ]),
                  ])
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "v-tabs-items",
              {
                model: {
                  value: _vm.tab,
                  callback: function ($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab",
                },
              },
              _vm._l(_vm.items, function (item, index) {
                return _c("v-tab-item", { key: index }, [
                  _c(
                    "div",
                    { staticClass: "tapes-tabs__list" },
                    _vm._l(item.tapes, function (tape, id) {
                      return _c(
                        "div",
                        { key: id, staticClass: "tapes-tabs__item" },
                        [
                          _c("img", {
                            staticClass: "tapes-tabs__img",
                            attrs: { src: tape.img, alt: tape.name },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "tapes-tabs__info" }, [
                            _c("h3", { staticClass: "tapes-tabs__title" }, [
                              _vm._v(_vm._s(tape.name)),
                            ]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "tapes-tabs__btn btn-red",
                                attrs: {
                                  href: "javascript:void(0)",
                                  onclick: "scrollOnBlock(formNew)",
                                },
                              },
                              [_vm._v("Оставить заявку")]
                            ),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ])
              }),
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }